import * as types from '../mutation-types/pages'

// set this true to namespace all getters, mutations, actions etc.
const namespaced =  true
export const namespace = 'Pages'

// state
const state = {
  postVerificationRoute: null,
  postVerificationRouteData: null,
  postLoginRoute: null,
  postLoginRouteData: null,
  savedLastRoute: null,
  savedLastRouteData: {},
  showGlobalTimer: true,
  promises: {}
}

// mutations
const mutations = {
  [types.SET_POST_VERIFICATION_ROUTE](state, page) {
    state.postVerificationRoute = page
  },
  [types.SET_POST_VERIFICATION_ROUTE_DATA](state, data) {
    state.postVerificationRouteData = data
  },
  [types.SET_POST_LOGIN_ROUTE](state, page) {
    state.postLoginRoute = page
  },
  [types.SET_POST_LOGIN_ROUTE_DATA](state, data) {
    state.postLoginRouteData = data
  },
  [types.SET_LAST_ROUTE](state, page) {
    state.postLoginPage = page
  },
  [types.SET_LAST_ROUTE_DATA](state, data) {
    state.postLoginSection = data
  },
  [types.HIDE_GLOBAL_TIMER](state) {
    state.showGlobalTimer = false
  },
  [types.SHOW_GLOBAL_TIMER](state, hide) {
    state.showGlobalTimer = true
  },
  [types.SET_PROMISE](state, promise) {
    const promises = state.promises
    promises[promise] = true
    state.promises = promises
  }
}

const actions = {
  savePostVerificationPage({commit}, {page, options}) {
    commit(types.SET_POST_VERIFICATION_ROUTE, _.isString(page) ? page : page.name)
    commit(types.SET_POST_VERIFICATION_ROUTE_DATA, options)
  },
  savePostLoginPage({commit}, {page, options}) {
    commit(types.SET_POST_LOGIN_ROUTE, _.isString(page) ? page : page.name)
    commit(types.SET_POST_LOGIN_ROUTE_DATA, options)
  },
  savePageBeforeLeave({commit}, {page, options}) {
    commit(types.SET_LAST_ROUTE, _.isString(page) ? page : page.name)
    commit(types.SET_LAST_ROUTE_DATA, options)
  },
  allowShowingGlobalTimer({commit}) {
    commit(types.SHOW_GLOBAL_TIMER)
  },
  hideGlobalTimer({commit}) {
    commit(types.HIDE_GLOBAL_TIMER)
  },
  setServicePromise({commit}, promise) {
    commit(types.SET_PROMISE, promise)
  }
}

// getters
const getters = {
  servicePromises: state => state.promises,
  savedLastRoute: state => ({name: state.savedLastRoute, options: state.savedLastRouteData}),
  showingGlobalTimer: state => state.showGlobalTimer,
  savedPostVerificationRoute: state => (state.postVerificationRoute && {name: state.postVerificationRoute, options: state.postVerificationRouteData}),
  savedPostLoginRoute: state => (state.postLoginRoute && {name: state.postLoginRoute, options: state.postLoginRouteData}),
}

const pages = { namespaced, namespace, state, mutations, actions, getters }
export default pages
